export default {
    UPDATE_USER: 'UPDATE_USER',
    UPDATE_ZP: 'UPDATE_ZP',
    UPDATE_USER_RESTRICTIONS: 'UPDATE_USER_RESTRICTIONS',
    UPDATE_CONFIG: 'UPDATE_CONFIG',
    UPDATE_TOTAL_IN_GAME_ONLINE: 'UPDATE_TOTAL_IN_GAME_ONLINE',
    UPDATE_NOTIFICATIONS: 'UPDATE_NOTIFICATIONS',
    SET_LAST_NOTIFICATION_ID: 'SET_LAST_NOTIFICATION_ID',
    UPDATE_COMPONENT_VISIBILITY: 'UPDATE_COMPONENT_VISIBILITY',
    HIDE_COMPONENT_VISIBILITY: 'HIDE_COMPONENT_VISIBILITY'
}
